import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PEV } from "src/common/utils";
import { ProgressErrorValue } from "src/common/utils/progress-error-value";
import { fetchAllSystemUserGroups } from "../service/system-user-group";
import { Principal } from "./information-asset-accesses";

export class SystemUserGroup {
  systemUserGroupId: string;
  systemId: string;
  name: String;
  members: Principal[];

  constructor(systemUserGroup: SystemUserGroup) {
    this.name = systemUserGroup.name;
    this.systemId = systemUserGroup.systemId;
    this.members = systemUserGroup.members;
    this.systemUserGroupId = systemUserGroup.systemUserGroupId;
  }
}

export interface InformationSystemUserGroup {
  systemUserGroupsPEV: ProgressErrorValue<SystemUserGroup[]>;
}

const initialState: InformationSystemUserGroup = {
  // @ts-ignore
  systemUserGroupsPEV: PEV([], "Not loaded yet"),
};

const getAllSystemUserGroups = createAsyncThunk("system-user-groups/fetch", async () => {
  return await fetchAllSystemUserGroups();
});

const informationSystemUserGroupSlice = createSlice({
  name: "informationSystemUserGroup",
  initialState,
  reducers: {
    updateInformationSystemUserGroupState: (
      state: InformationSystemUserGroup,
      action: PayloadAction<Partial<InformationSystemUserGroup>>
    ) => ({
      ...state,
      ...action.payload,
    }),
    resetSystemUserGroups(state) {
      state.systemUserGroupsPEV = initialState.systemUserGroupsPEV;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllSystemUserGroups.pending, (state) => {
        state.systemUserGroupsPEV = PEV(
          state.systemUserGroupsPEV.value, // @ts-ignore
          "Fetching information assets accesses"
        );
      })
      .addCase(getAllSystemUserGroups.fulfilled, (state, action) => {
        state.systemUserGroupsPEV = PEV(action.payload);
      })
      .addCase(getAllSystemUserGroups.rejected.type, (state, action) => {
        // @ts-ignore
        state.systemUserGroupsPEV = PEV(
          state.systemUserGroupsPEV.value,
          null, // @ts-ignore
          "Error while fetching assets accesses"
        );
      });
  },
});

const {resetSystemUserGroups }=informationSystemUserGroupSlice.actions
export const InformationSystemUserGroupReducer = informationSystemUserGroupSlice.reducer;

export const InformationSystemUserGroupActions = {
  getAllSystemUserGroups,
  resetSystemUserGroups
};
